import script from "./compareItem.vue?vue&type=script&setup=true&lang=js"
export * from "./compareItem.vue?vue&type=script&setup=true&lang=js"

import "./compareItem.vue?vue&type=style&index=0&id=5466c2da&lang=less&scoped=true"

import exportComponent from "D:\\workspaceJava\\wlyc\\wlyc\\tianjing-client-web-develop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5466c2da"]])

export default __exports__